import { useMutation } from 'react-query';

import { FinalizeGiftPurchaseParams, confirmGift } from '../utils/backend-api/groupSubscription';

export default function useGiftConfirm() {
  const { mutateAsync, data, isLoading, isError } = useMutation(
    (params: FinalizeGiftPurchaseParams) => confirmGift(params)
  );
  return { mutateAsync, data, isLoading, isError };
}
